import React,{useState, useEffect} from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Form, DatePicker, Select, Radio } from 'antd';
import FormSteps from '../Form/Form';
import { useSelector } from 'react-redux';
import moment from 'moment'

const Cittadinanza = () => {

    const { Option } = Select;

    //const apiPath = useSelector(state => state.dataReducer.dataApiPath);
    //const esitoControllo = useSelector(state => state.dataReducer.controlloCittadinanza.esitoControllo);
    const errorMessage = useSelector(state => state.dataReducer.controlloCittadinanza.errorMessage);

    //const codice_fiscale_store = useSelector(state => state.dataReducer.modello.datiPratica.codiceFiscale);

    const ErroriSalvaStep = useSelector(state => state.dataReducer.salvaStep.dati);

    const [errorMessageScadenzaSoggiorno, setErrorMessageScadenzaSoggiorno] = useState(null);
    const [errorMessageCittadinanza, setErrorMessageCittadinanza] = useState(null);
    const [errorMessageTipoPermessoSoggiorno, setErrorMessageTipoPermessoSoggiorno] = useState(null);

    useEffect(() => {
        if(ErroriSalvaStep){
            ErroriSalvaStep.forEach(errore => {
                switch(errore.errorCode) {
                    case "dataScadenzaSoggiorno":
                        setErrorMessageScadenzaSoggiorno(errore.errorMessage);
                    break;
                    case "cittadinanza":
                        setErrorMessageCittadinanza(errore.errorMessage);
                    break;
                    case "tipoPermessoSoggiorno":
                        setErrorMessageTipoPermessoSoggiorno(errore.errorMessage);
                    break;
                    default:
                        setErrorMessageScadenzaSoggiorno(null);
                        setErrorMessageCittadinanza(null);
                        setErrorMessageTipoPermessoSoggiorno(null);
                    break;
                }
            });
        }else{
            setErrorMessageScadenzaSoggiorno(null);
            setErrorMessageCittadinanza(null);
            setErrorMessageTipoPermessoSoggiorno(null);
        }
    }, [ErroriSalvaStep]);

    const cittadinanza_store = useSelector(state => state.dataReducer.modello.datiPratica.cittadinanza);
    const tipoPermessoSoggiorno = useSelector(state => state.dataReducer.modello.datiPratica.tipoPermessoSoggiorno);

    const [cittadinanza, setCittadinanza] = useState(cittadinanza_store || '');
    const [soggiorno, setSoggiorno] = useState(tipoPermessoSoggiorno || '');
    //const dispatch = useDispatch();

    let dateToday = moment().format('YYYY-MM-DD');
    let date1Year = (moment().add(1, 'years')).format('YYYY-MM-DD');
    let date2Years = (moment().add(2, 'years')).format('YYYY-MM-DD');
    let date3Years = (moment().add(3, 'years')).format('YYYY-MM-DD');
    let date5Years = (moment().add(5, 'years')).format('YYYY-MM-DD');
    let date10Years = (moment().add(10, 'years')).format('YYYY-MM-DD');

    function cambioCittadinanza(valueCit) {
       // await dispatch(getControlloCittadinanza(valueCit.target.value,codice_fiscale_store,apiPath));
        setCittadinanza(valueCit.target.value);
    }

    function cambioPermesso(valueSogg) {
        setSoggiorno(valueSogg);
    }

    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='Cittadinanza' 
                        sottotitolo ='' />

            <FormSteps formId="step5">

                <Form.Item name="cittadinanza" help={errorMessageCittadinanza || errorMessage || null}
                rules={[
                    {
                        required: true,
                        message: 'Scegli la cittadinanza',
                    }
                ]}
                >
                    <Radio.Group onChange={cambioCittadinanza} >
                        <Radio.Button value="IT" className={stylesForm.threeRadioButton}>Italiana</Radio.Button>
                        <Radio.Button value="EU" className={stylesForm.threeRadioButton}>Comunitaria</Radio.Button>
                        <Radio.Button value="EX" className={stylesForm.threeRadioButton}>Extra UE</Radio.Button>
                    </Radio.Group>
                </Form.Item>

            {
                (cittadinanza === 'EX') ? (

                    <>
                    <label className={stylesForm.floatingLabel} htmlFor="tipoPermessoSoggiorno">Tipo di permesso di soggiorno*</label>
                    <Form.Item name="tipoPermessoSoggiorno" help={errorMessageTipoPermessoSoggiorno}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Scegli la tipologia di permesso di soggiorno',
                                    }
                                ]}
                                >
                        <Select onChange={cambioPermesso} placeholder='Tipo di permesso di soggiorno*'>
                            <Option value={null}>Seleziona permesso di soggiorno</Option>
                            <Option value="PSI">Permesso indeterminato</Option>
                            <Option value="PS1">Permesso Determinato 1 anno</Option>
                            <Option value="PS2">Permesso Determinato 2 anni</Option>
                            <Option value="PS3">Permesso Determinato 3 anni</Option>
                            <Option value="PS5">Permesso Determinato 5 anni</Option>
                            <Option value="P10">Permesso Determinato 10 anni</Option>
                        </Select>
                    </Form.Item>
                    </>

                ) : null
            }


            {
                (cittadinanza === 'EX' && (
                    soggiorno === 'PS1' ||
                    soggiorno === 'PS2' ||
                    soggiorno === 'PS3' ||
                    soggiorno === 'PS5' ||
                    soggiorno === 'P10'
                )) ? (

                    <>
                    <label className={stylesForm.floatingLabel} htmlFor="dataScadenzaSoggiorno">Data scadenza soggiorno</label>
                    <Form.Item name="dataScadenzaSoggiorno"  help={errorMessageScadenzaSoggiorno ? errorMessageScadenzaSoggiorno : null } >
                        {
                            soggiorno === 'PS1' ? (
                                <DatePicker placeholder="Seleziona data" format="DD/MM/YYYY" disabledDate={d => !d || d.isSameOrBefore(dateToday) || d.isSameOrAfter(date1Year)} />
                            ) : soggiorno === 'PS2' ? (
                                <DatePicker placeholder="Seleziona data" format="DD/MM/YYYY" disabledDate={d => !d || d.isSameOrBefore(dateToday) || d.isSameOrAfter(date2Years)} />
                            ) : soggiorno === 'PS3' ? (
                                <DatePicker placeholder="Seleziona data" format="DD/MM/YYYY" disabledDate={d => !d || d.isSameOrBefore(dateToday) || d.isSameOrAfter(date3Years)} />
                            ) : soggiorno === 'PS5' ? (
                                <DatePicker placeholder="Seleziona data" format="DD/MM/YYYY" disabledDate={d => !d || d.isSameOrBefore(dateToday) || d.isSameOrAfter(date5Years)} />
                            ) : soggiorno === 'P10' ? (
                                <DatePicker placeholder="Seleziona data" format="DD/MM/YYYY" disabledDate={d => !d || d.isSameOrBefore(dateToday) || d.isSameOrAfter(date10Years)} />
                            ) : null
                        }
                    </Form.Item>
                    </>
                ) : ''
            }

            </FormSteps>
        </div>
    )
}

export default Cittadinanza;